// app/javascript/controllers/selectable_controller.js
import { Controller } from "stimulus";

export default class extends Controller {

  toggleAll(event) {
    const isChecked = event.target.checked;
    this.checkboxes.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
    this.updateButtons();
  }

  toggle() {
    this.updateButtons();
  }

  updateButtons() {
    const selected = this.checkboxes.filter(checkbox => checkbox.checked);
    const deletableCount = selected.filter(checkbox => checkbox.dataset.deletable === "true").length;
    this.updateButton(document.getElementById("destroy-selected-btn"), deletableCount, "Delete Selected");
    this.updateButton(document.getElementById("edit-selected-btn"), selected.length, "Edit Selected");
  }

  updateButton(button, count, label) {
    if (!button) return;

    button.classList.toggle("invisible", count === 0);
    const text = `${label} (${count})`;
    button.tagName === "INPUT" ? button.value = text : button.textContent = text;
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const form = event.target;
    form.querySelectorAll('input[type="hidden"][name="survey_response_ids[]"]').forEach(input => input.remove());

    this.checkboxes
      .filter(checkbox => checkbox.checked)
      .forEach(checkbox => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'survey_response_ids[]';
        input.value = checkbox.value;
        form.appendChild(input);
      });

    form.submit();
  }

  get checkboxes() {
    return Array.from(document.querySelectorAll('input[type="checkbox"][name="survey_response_ids[]"]'));
  }
}
